import styles from './styles';

import * as React from 'react';

import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';

import Dialog from 'bz-core-controls/controls/modal/dialog/internal';

import TerminalSelect from './terminal-select';
import InProgress from './in-progress';
import Error from './error';
import type TerminalPaymentDialogStore from './stores/terminal-payment-dialog-store';
import TerminalDialogHeader from 'bz-core-controls/controls/payments/shared/terminal-payment/dialog-header';
import ShowFor from 'tm3-core/controls/showFor';
import HideFrom from 'tm3-core/controls/hideFrom';

import { IsProduct } from 'tm3-core/enums/product-enum';
import ClickDialog from 'click-controls/controls/dialog';

interface IProps extends WithStyles<typeof styles> {
  terminalPaymentDialogStore?: TerminalPaymentDialogStore;
}

@inject('terminalPaymentDialogStore')
@observer
class TerminalPaymentDialog extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
    props.terminalPaymentDialogStore?.load();
  }
  render() {
    const { terminalPaymentDialogStore } = this.props;

    let content = <CircularProgress />;
    if (terminalPaymentDialogStore!.loaded && !terminalPaymentDialogStore!.loading) {
      content = (
        <React.Fragment>
          <TerminalSelect />
          <InProgress />
          <Error />
        </React.Fragment>
      );
    }

    return (
      <>
        <ShowFor product={IsProduct.Click}>
          <ClickDialog
            containerClass={`max-h-full`}
            bodyClass="max-h-96 overflow-y-auto"
            width="1/2"
            isOpen={terminalPaymentDialogStore!.dialogOpen}
            title={'Terminal Payment'}
            centered={true}
            closable={true}
            displayFooter={false}
            onClose={() => terminalPaymentDialogStore!.onCancel()}
          >
            <div>{content}</div>
            {terminalPaymentDialogStore?.showUnloadWarning && (
              <div className="m-3 rounded-md border-2 border-rose-500 bg-rose-100 p-3 text-lg font-bold text-rose-600">
                If you reload the page with a transaction in process, it may result in a payment
                taken against the card, but not registered in {z.word('Click')}
              </div>
            )}
          </ClickDialog>
        </ShowFor>
        <HideFrom products={[IsProduct.Click]}>
          <Dialog
            open={terminalPaymentDialogStore!.dialogOpen}
            header={<TerminalDialogHeader title={'Terminal Payment'} />}
          >
            <div>{content}</div>
            {terminalPaymentDialogStore?.showUnloadWarning && (
              <div className="m-3 rounded-md border-2 border-rose-500 bg-rose-100 p-3 text-lg font-bold text-rose-600">
                If you reload the page with a transaction in process, it may result in a payment
                taken against the card, but not registered in {z.word('TM3')}
              </div>
            )}
          </Dialog>
        </HideFrom>
      </>
    );
  }
}

export default withStyles(styles)(TerminalPaymentDialog);
